import React from "react";
import { useTranslation } from "react-i18next";
import { Row } from "react-bootstrap";
import { PrizeTablesGrid, PrizeTablesTitleBar } from "./TBCBStyledComponents";
import TBCBPrizeTable from "./TBCBPrizeTable";

/**
 * Reusable Prize Tables Grid Component for TBCB promotional pages
 * 
 * @param {Object} props
 * @param {string} props.translationKeyPrefix - The translation key prefix (e.g., "tripleBarrelCashBlast2026")
 * @param {string} props.imagePath - Path to images: "2025" or "2026"
 * @param {string} props.layout - Layout type: "grid" or "bootstrap"
 * @returns {JSX.Element}
 */
const TBCBPrizeTablesSection = ({
  translationKeyPrefix,
  imagePath,
  layout = "grid",
}) => {
  const { t } = useTranslation();

  const prizeTables = t(`${translationKeyPrefix}.content.prizeTables`, {
    returnObjects: true,
  });

  const Container = layout === "bootstrap" ? Row : PrizeTablesGrid;
  const containerProps = layout === "bootstrap" 
    ? { className: "justify-content-center gap-lg-2 mx-0 px-0 align-items-stretch" }
    : {};

  return (
    <>
      <PrizeTablesTitleBar>
        <h2>{t(`${translationKeyPrefix}.content.prizeTablesTitle`)}</h2>
      </PrizeTablesTitleBar>
      <Container {...containerProps}>
        {["diamond", "gold", "silver"].map((key, index) => (
          <TBCBPrizeTable
            key={key}
            prizeType={key}
            tableData={prizeTables?.[key]}
            imagePath={imagePath}
            gridColumn={index + 1}
            layout={layout}
          />
        ))}
      </Container>
    </>
  );
};

export default TBCBPrizeTablesSection;
